<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Error</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  Can only exchange a single unmatched CWAN position and a single unmatched/zero
  external position
</div>
